import { Component, OnInit, ChangeDetectionStrategy, ViewChild, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AsamcoUserService } from '@asamco/base';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { LinkDescriptionService } from '../../services/link-description.service';
import { LinkEditInfoModalComponent } from '../link-edit-info-modal/link-edit-info-modal.component';
import { UnescapePipe } from '../../pipes/html_unescape.pipe';
import { SanitizePipe } from '../../pipes/santizehtml.pipe';

@Component({
    selector: 'al-link-edit-information',
    templateUrl: './link-edit-information.component.html',
    styleUrls: ['./link-edit-information.component.scss'],
    standalone: true,
    imports: [
        LinkEditInfoModalComponent,
        SanitizePipe,
        UnescapePipe,
    ],
})
export class LinkEditInformationComponent implements OnInit, OnDestroy {
	@ViewChild(LinkEditInfoModalComponent)
	editInfoModal: LinkEditInfoModalComponent;

	@Input()
	linkInfo: MarketPlaceItem;

	private destroy$ = new Subject<void>();
	public canManageApplicationLinkAdministration: boolean = false;
	formGroup: FormGroup;
	formInitialized: boolean = false;

	constructor(private linkDescriptionService: LinkDescriptionService, private asamcoUserService: AsamcoUserService, public sanitizer:DomSanitizer) {}

	ngOnInit(): void {
		this.asamcoUserService.hasAssignedPermission('AL3_ADMINISTRATION').then(result => (this.canManageApplicationLinkAdministration = result));
		this.initializeFormGroup();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	initializeFormGroup() {
		this.formGroup = new FormGroup({
			jobsRun: new FormControl(''),
			jobsSucceeded: new FormControl(''),
			jobsFailed: new FormControl(''),
		});
		this.formInitialized = true;
	}

	openModal(): void {
		if (this.canManageApplicationLinkAdministration === false) return;
		else {
			this.editInfoModal
				.show('long description', this.linkInfo.longDescription)
				.pipe(takeUntil(this.destroy$))
				.subscribe(result => {
					this.linkInfo.longDescription = result;
					this.linkDescriptionService.setLongDescription(this.linkInfo.id, result).pipe(takeUntil(this.destroy$)).subscribe({error: console.error});
				});
		}
	}
}
